import { IDmData, panelType } from '@bimser/common';
import { BCTabs, ITabsItem, findMessage } from '@bimser/components';
import * as React from 'react';
import AppFormContainer from '../../../../../../../common/components/appForm';
import { IWebInterfaceAction } from '../../../../../../../common/entities';
import Style from '../assets/style.scss';
import { IProfileFormData } from '../entities/IProfileFormData';

interface IProfilesTabsProps {
	panelGuid: string;
	dmObject: IDmData;
	formData: IProfileFormData[];
	selectedIds: string[];
	activeTabKey: string;
	initializedForms?: any;
	initializePanelManager?: (action: IWebInterfaceAction) => void;
	onTabChange?: (activeKey: string) => void;
}

const ProfilesTabs = (props: IProfilesTabsProps) => {
	React.useEffect(() => {
		props.onTabChange(props.dmObject.properties.metaData.value.profiles[0].formId);
	}, []);

	const NoFileSelected = () => (
		<div className={Style.noFileSelected}>
			<span>{findMessage.get('100026')}</span>
			<span>{findMessage.get('102308')}</span>
		</div>
	);

	const getTabItems = (): ITabsItem[] =>
		props.dmObject.properties.metaData.value.profiles.map(
			profile =>
				({
					key: profile.formId,
					label: <span>{profile.formName + (profile.isRequired ? '(*)' : '')}</span>,
					children: renderTabContent(profile.formId)
				}) as ITabsItem
		);

	const renderTabContent = (key: string) => {
		const form = props.formData.find(f => f.formData.formId == key);
		if (!form) {
			return <NoFileSelected />;
		}
		const formViewerId = props.selectedIds.length > 1 ? key + '_multiple' : form.formViewerId;
		const childFormData = { ...form.formData, secretKey: form.formSecretKey };
		if (!props.initializedForms[formViewerId]) {
			//initializePanelManager
			AppFormContainer.onPanelOpening({
				componentProps: [
					{
						props: {
							projectName: form.formData.projectName
						}
					}
				]
			}).then(() => {
				props.initializePanelManager({
					panelId: formViewerId,
					panelType: panelType.eBAApplicationForm,
					data: {
						parentPanel: {
							panelGuid: props.panelGuid,
							panelType: panelType.profileForm
						}
					}
				});
			});
		}

		return (
			<AppFormContainer
				key={formViewerId}
				documentId={form.documentId}
				childFormData={childFormData}
				panelGuid={formViewerId}
				hideFormToolbar
				projectName={form.formData.projectName}
			/>
		);
	};

	return (
		<div>
			<BCTabs
				items={getTabItems()}
				activeKey={props.activeTabKey}
				onChange={props.onTabChange}
				destroyInactiveTabPane
			/>
		</div>
	);
};

export default ProfilesTabs;
